import { type LineItemPayload } from '~/types/LineItem';

import { ActionKeys } from './constants';

export const createLineItem = (
  orderObjectId: string,
  lineItemPayload: LineItemPayload,
  refreshBatchEntry = false,
) =>
  <const>{
    payload: {
      lineItemPayload,
      orderObjectId,
      refreshBatchEntry,
    },
    type: ActionKeys.LINE_ITEM_CREATE,
  };

export const createLineItemSuccess = () =>
  <const>{
    type: ActionKeys.LINE_ITEM_CREATE_SUCCESS,
  };

export const createLineItemError = () =>
  <const>{
    type: ActionKeys.LINE_ITEM_CREATE_ERROR,
  };

export const deleteLineItem = (id: string, orderObjectId: string, refreshBatchEntry = false) =>
  <const>{
    payload: { id, orderObjectId, refreshBatchEntry },
    type: ActionKeys.LINE_ITEMS_DELETE,
  };

export const deleteLineItemSuccess = () =>
  <const>{
    type: ActionKeys.LINE_ITEMS_DELETE_SUCCESS,
  };

export const deleteLineItemError = () =>
  <const>{
    type: ActionKeys.LINE_ITEMS_DELETE_ERROR,
  };

export const editLineItem = (
  lineItemObjectId: string,
  orderObjectId: string,
  lineItemPayload: LineItemPayload,
  refreshBatchEntry = false,
) =>
  <const>{
    payload: {
      lineItemObjectId,
      lineItemPayload,
      orderObjectId,
      refreshBatchEntry,
    },
    type: ActionKeys.LINE_ITEM_EDIT,
  };

export const editLineItemSuccess = () =>
  <const>{
    type: ActionKeys.LINE_ITEM_EDIT_SUCCESS,
  };

export const editLineItemError = () =>
  <const>{
    type: ActionKeys.LINE_ITEM_EDIT_ERROR,
  };

export type LineItemActions =
  | ReturnType<typeof createLineItem>
  | ReturnType<typeof createLineItemError>
  | ReturnType<typeof createLineItemSuccess>
  | ReturnType<typeof deleteLineItem>
  | ReturnType<typeof deleteLineItemError>
  | ReturnType<typeof deleteLineItemSuccess>
  | ReturnType<typeof editLineItem>
  | ReturnType<typeof editLineItemError>
  | ReturnType<typeof editLineItemSuccess>;
